import React from 'react'
import PropTypes from 'prop-types'

class Toolbar extends React.Component {
  static propTypes = {
    view: PropTypes.string.isRequired,
    views: PropTypes.arrayOf(PropTypes.string).isRequired,
    label: PropTypes.node.isRequired,
    localizer: PropTypes.object,
    onNavigate: PropTypes.func.isRequired,
    onView: PropTypes.func.isRequired
  }

  render() {
    return null
  }
}

export default Toolbar



// WEBPACK FOOTER //
// ./src/features/calendar/toolbar.js